<template>
      <ob-modal2 :show.sync="show" :type="1" width="50%">
            <div class="modal-everify-alert">
                  <div class="modal-everify-alert-body">
                        <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_alert.svg`" style="width:60px;" />
                        <h1 class="everify-alert-heading">Attention!</h1>
                        <div class="everify-alert-description">
                              <p>Your ESS access has been disabled for {{this.OrgName}}.<br>Please contact your Employer for more information.</p>
                        </div>
                        <div class="modal-everify-alert-footer">
                              <ob-button type="primary" class="upload-old-everify" @click="Proceed">Proceed</ob-button>
                        </div>
                  </div>
            </div>
      </ob-modal2>
</template>
<script>
export default{  
      props:["openModal", "OrgName"],  
      data(){
            return{
                  show:false,
            }

      },
      created(){
           
      },   
      watch:{
            openModal(val) {
                 this.show = val;
            },
            show(val) {
                  this.$emit('update:openModal', val)
            }
      },  
      methods:{
            Proceed(){
                  this.show = false
                  window.location.reload() 
            }
      }
    
}
</script>
<style lang="scss" scoped>
      .modal-everify-alert {
            text-align: center;
            padding: 8px;
      }

      .modal-everify-alert-body {
            font-weight: 600;
            margin: 25px;
      }
      
      .everify-alert-heading {
            color: #333;
            font-size: 24px;
            font-weight: 500;
            transform: scale(.97, 1);
      }
      .everify-alert-description p {
            color: #707070;
            font-size: 13px;
            font-weight: inherit;
            transform: scale(1, 1.2);
            padding-top: 10px;
            line-height: 1.5;
            padding-bottom: 18px;
            font-weight: normal;
      }
      .modal-everify-alert-footer {
            padding-top: 18px;
      }
      
      .upload-old-everify {
            width: 80px !important;
            height: 30px;
      }


</style>


// WEBPACK FOOTER //
// src/components/DisabledOrganization.vue